import React, { useState } from "react";
import styles from "./Slide2.module.scss";
import {
  RecordingRoomDiagram,
  RecordingRoomItem,
} from "@src/lms/jelly/extensions/layouts/_lesson/guide04/production/image/RecordingRoomDiagram";
import ProdRoom2Am from "./prod_room_2_am.svg";
import ProdRoom2lav from "./prod_room_2_lav.svg";

export const Slide2: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<RecordingRoomItem | null>(null);

  const handleItemSelect = (id: RecordingRoomItem | null): void => {
    setSelectedItem(id);
  };

  // Get the appropriate SVG component based on selected item
  const getCurrentSvgComponent = (): React.ComponentType => {
    switch (selectedItem) {
      case "lav":
        return ProdRoom2lav;
      default:
        return ProdRoom2Am; // Default overview
    }
  };

  // Get the diagram key for React reconciliation
  const getCurrentDiagramKey = (): string => {
    return selectedItem || "default";
  };

  return (
    <div className={styles.slide}>
      <RecordingRoomDiagram
        key={getCurrentDiagramKey()}
        diagramKey={getCurrentDiagramKey()}
        SvgComponent={getCurrentSvgComponent()}
        onItemSelect={handleItemSelect}
      />
    </div>
  );
};
